import React from "react"
import { Link } from "react-router-dom"
import { useSiteContent } from "../../content/SiteContentContext.jsx"
import { RichText } from "../../utils/richText.jsx"

const Footer = () => {
  const { footer, locations } = useSiteContent();
  const links = footer?.links || [];
  const sedes = Array.isArray(locations) ? locations : [];

  return (
    <footer className="brand-gradient text-white py-10 mt-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <h3 className="text-lg font-semibold mb-4">{footer?.aboutTitle}</h3>
              <RichText html={footer?.aboutText} className="text-justify text-white/75" />
            </div>
            <div className="lg:col-span-3">
              <h3 className="text-lg font-semibold mb-4">{footer?.linksTitle}</h3>
              <ul className="list-none">
                {links.map((item, index) => (
                  <li className="mb-2" key={index}>
                    <Link to={item.link || "/contacto"} className="text-white/75 hover:text-white transition-colors">
                      {item.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:col-span-4">
              <h3 className="text-lg font-semibold mb-4">{footer?.contactTitle}</h3>
              <div className="flex flex-col gap-4">
                {sedes.map((sede, index) => (
                  <div key={sede.id || index}>
                    {sede.name ? (
                      <p className="text-sm font-semibold text-white/95 flex items-center gap-2">
                        <i className="fa-solid fa-location-dot text-[#9db8ff]" /> {sede.name}
                      </p>
                    ) : null}
                    {sede.address ? <p className="text-sm text-white/70 mt-1">{sede.address}</p> : null}
                    {sede.phone ? <p className="text-sm text-white/70 mt-0.5">{sede.phone}</p> : null}
                  </div>
                ))}
              </div>
              <div className="mt-5 pt-5 border-t border-white/15 text-sm text-white/70">
                <p className="mb-1">Email: {footer?.email}</p>
                <p>Teléfono: {footer?.phone}</p>
              </div>
            </div>
          </div>
          {/* Titular de la marca: fijo (no editable desde el CMS) porque liga "INCAP" con la persona
              de la constancia fiscal; lo revisan la verificación de Meta y el aviso de privacidad. */}
          <p className="mt-8 pt-4 border-t border-white/10 text-xs text-white/50 text-right">
            <Link to="/aviso-de-privacidad" className="hover:text-white transition-colors underline-offset-2 hover:underline">
              Aviso de privacidad
            </Link>
            <span className="mx-2">·</span>
            INCAP es una marca operada por Adelaida Fernandez Ramos
          </p>
        </div>
      </footer>
  )
}

export default Footer
